<template>
  <div  class="login_contenter">
    <loginHeader></loginHeader>
    <div class="login_content" :class="{isPopFrame}">
      <div class="login_cont">
        <div class="login_form">
          <closeModalBtn ref="closeModalBtn"/>
          <div class="login_item">
            <h2 class="forgetTitle"><i class="el-icon-success"></i>{{ $t('SaoMaChengGongQingBangDingPingTaiZhangHao') }}</h2>
            <div class="login_form_cont">
              <el-form :rules="rules" ref="wxForm" :model="wxForm" label-width="0px" size="medium">
                <el-form-item prop="tel">
                  <el-input v-model="wxForm.tel" :placeholder="$t('ShouJiHaoYouXiang')" :readonly="btnStatus.wxBindBtn || forAutoComplete"></el-input>
                  <span class="item-error el-form-item__error" slot="error">
                    {{checkTelEmailErrorMsg}}
                    <a v-show="toLogina" @click="toLoginFn" style="cursor: pointer;">{{ $t('QuDengLu') }}&gt;&gt;</a>
                  </span>
                </el-form-item>
                <el-form-item prop="verificationCode">
                  <el-input v-model="wxForm.verificationCode" :placeholder="$t('TuXingYanZhengMa')" style="width: calc(100% - 150px);" :readonly="btnStatus.wxBindBtn || forAutoComplete" maxlength="6"></el-input>
                  <img class="imgCode" @click="loginChangeCodeFn('wxNoteImgCode')" :src="imgCodeData.wxNoteImgCode" :alt="$t('YanZhengMa')" :title="$t('DianJiQieHuanYanZhengMa')">
                </el-form-item>
                <el-form-item prop="telVerificationCode">
                  <el-input v-model="wxForm.telVerificationCode" :placeholder="$t('YanZhengMa')" maxlength="6" :readonly="btnStatus.wxBindBtn || forAutoComplete"></el-input>
                  <el-button class="getNoteCodeBtn" type="text" @click="getNoteCode" :disabled="noteCodeBtn">{{telCodeText}}</el-button>
                </el-form-item>
                <el-form-item size="large">
                  <el-button type="primary" class="loginBtn" @click="wxSubmit" :loading="btnStatus.wxBindBtn">{{ $t('QueDing') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="wxBindText sy_text_c">{{ $t('WeiZhuCeDeShouJiHaoYouXiangYanZhengChengGongHouJiangZiDongZhuCe') }}</div>
            <div class="sy_login_bottom sy_text_c">
              <i18n path="ZanBuBangDing">
                <template #link>
                  <span @click="goOthersLogin" style="cursor: pointer;color: var(--font-color);">{{ $t('XuanZeQiTaFangShiDengLu') }} <i class="el-icon-right"></i></span>
                </template>
              </i18n>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <loginFooter></loginFooter>-->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import loginHeader from '@/components/loginPublic/loginHeader'
import loginFooter from '@/components/loginPublic/loginFooter'

export default {
  name: 'wxLogin',
  components: { loginHeader, loginFooter },
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuTuXingYanZhengMa')))
      } else if (!(/^\S{4}$/).test(value)) {
        callback(new Error(this.$t('TuXingYanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuYanZhengMa')))
      } else if (!(/^[0-9]{6}$/).test(value)) {
        callback(new Error(this.$t('YanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var checkTelEmail = (rule, value, callback) => {
      this.toLogina = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else if (!(/^1[3-9][0-9]{9}$/).test(value) && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        const obj = {
          url: this.type === 'wx' ? '/wx/isPhoneBoundToWeChat' : '/ding/isPhoneBoundToDing',
          value
        }
        this.getUserWXExistFn(obj).then((res) => {
          if (res.success) {
            callback()
          } else {
            this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoYouXiangYiBangDingQiTaWeiXinHao', [this.SFName])
            callback(new Error(this.checkTelEmailErrorMsg))
            this.toLogina = true
          }
        }).catch(() => {
          callback()
        })
      }
    }
    var checktel = (rule, value, callback) => {
      this.toLogina = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHao')
        return callback(new Error(this.checkTelEmailErrorMsg))
      }
      if (!(/^1[3-9][0-9]{9}$/).test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHao')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        const obj = {
          url: this.type === 'wx' ? '/wx/isPhoneBoundToWeChat' : '/ding/isPhoneBoundToDing',
          value
        }
        this.getUserWXExistFn(obj).then((res) => {
          if (res.success) {
            callback()
          } else {
            this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoYiBangDingQiTaWeiXinHao', [this.SFName])
            callback(new Error(this.checkTelEmailErrorMsg))
            this.toLogina = true
          }
        }).catch(() => {
          callback()
        })
      }
    }
    return {
      codeTimer: 0,
      noteCodeInterval: null,
      noteCodeBtn: false,
      toLogina: false,
      forAutoComplete: true,
      wxForm: {
        tel: '',
        verificationCode: '',
        telVerificationCode: ''
      },
      openId: '',
      type: '',
      showBind: false,
      loading: null,
      checkTelEmailErrorMsg: '',
      rules: {
        tel: [
          { validator: checkTelEmail, trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validatePass, trigger: 'blur' }
        ],
        telVerificationCode: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations(['showMsg']),
    ...mapActions(['loginChangeCodeFn', 'getNoteCodeFn', 'getUserWXExistFn', 'getWXOpenIdFn', 'getWXIsBindUserFn', 'WXLoginFn', 'sfBindFn', 'sfLoginFn']),
    goOthersLogin () {
      this.$router.push('/')
    },
    toLoginFn () {
      this.$router.push('/?tel=' + this.wxForm.tel)
    },
    wxKeydown () {
      let that = this
      window.onkeydown = function (event) {
        let e = event || window.event
        if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'NumpadEnter')) {
          e.preventDefault()
          if (!that.btnStatus.wxBindBtn) {
            that.wxSubmit()
          }
        }
      }
    },
    getTelCode () {
      this.NoteCodeData.wxNoteCodeKey = ''
      this.getNoteCodeFn({
        imageCode: this.wxForm.verificationCode,
        imageCodeKey: this.imgCodeData.wxNoteImgCodeKey,
        account: this.wxForm.tel
      }).then((response) => {
        this.NoteCodeData.wxNoteCodeKey = response.data.SMSCodeKey
        this.codeTimer = 120
        this.noteCodeBtn = true
        this.noteCodeInterval = setInterval(() => {
          if (this.codeTimer > 0) {
            this.codeTimer--
          } else {
            this.noteCodeBtn = false
            clearInterval(this.noteCodeInterval)
          }
        }, 1000)
      }).catch((response) => {
        this.loginChangeCodeFn('wxNoteImgCode')
        this.noteCodeBtn = false
      })
    },
    getNoteCode () {
      this.noteCodeBtn = true
      this.$refs.wxForm.validateField('tel', (val, item) => {
        if (!val) {
          this.$refs.wxForm.validateField('verificationCode', (val, item) => {
            if (!val) {
              this.getTelCode()
            } else {
              this.noteCodeBtn = false
            }
          })
        } else {
          this.noteCodeBtn = false
        }
      })
    },
    wxSubmit () {
      this.$refs.wxForm.validate((valid) => {
        if (valid) {
          let wxData = {
            userId: '',
            userAccount: this.wxForm.tel,
            code: this.wxForm.telVerificationCode,
            codeKey: this.NoteCodeData.wxNoteCodeKey,
            userEmail: '',
            userPassword: '',
            source: this.loginSource.buryingPoint
          }
          let url
          if (this.type === 'wx') {
            wxData.userWxopenid = this.openId
            url = '/wx/bind'
          } else {
            wxData.userDingScanUnionid = this.openId
            url = '/ding/bind'
          }
          this.sfBindFn({
            url,
            params: wxData
          }).then((res) => {
            let wxLogin = {
              userAccount: this.wxForm.tel,
              source: this.loginSource.buryingPoint
            }
            let url
            if (this.type === 'wx') {
              wxLogin.wxOpenId = this.openId
              url = '/wxLogin'
            } else {
              wxLogin.dingUnionId = this.openId
              url = '/dingScanLogin'
            }
            this.sfLoginFn({
              url,
              params: wxLogin
            }).then((res) => {
              let token = res.data.Authentication
              this.loginIsSuccessfullyRedirected(token)
            }).catch((res) => {
              this.showMsg({ msg: (res.msg || this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.SFName])), type: 'error' })
              setTimeout(() => {
                this.$router.push('/')
              }, 3000)
            })
          }).catch(() => {})
        } else {
          return false
        }
      })
    },
    loginIsSuccessfullyRedirected (token) {
      this.setCookie('DTRANXTOKEN', token)
      if (this.isPopFrame) {
        this.$nextTick(() => {
          this.$refs.closeModalBtn.sendMsgOfSuccess(token)
        })
      } else {
        window.location.href = `${this.loginSource.url}`
      }
    }
  },
  mounted () {
    const { code, type } = this.$route.query
    this.openId = code
    this.type = type
    this.forAutoComplete = false
    this.loginChangeCodeFn('wxNoteImgCode')
    this.wxKeydown()
  },
  destroyed () {
    window.onkeydown = null
    clearInterval(this.noteCodeInterval)
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame,
      loginSource: state => state.publicModules.loginSource,
      modal: state => state.loginPublic.modal,
      imgCodeData: state => state.loginPublic.imgCodeData,
      NoteCodeData: state => state.loginPublic.NoteCodeData,
      btnStatus: state => state.loginPublic.btnStatus
    }),
    telCodeText () {
      if (this.codeTimer > 0) {
        return this.$t('TimerMiaoHouZhongXinFaSong', [this.codeTimer])
      }
      return this.$t('HuoQuYanZhengMa')
    },
    SFName () {
      return this.type === 'wx' ? this.$t('weiXin') : this.$t('dingDing')
    }
  }
}
</script>

<style scoped lang="scss">
.login_contenter {
  .login_content {
    min-height: 700px;
    &.isPopFrame{
      min-height: 538px;
    }

    .login_cont {
      .forgetTitle {
        font-size: 16px;
        color: var(--font-color);
        height: 24px;
        display: flex;
        align-items: center;
        i{
          color: #34c759;
          margin-right: 16px;
          font-size: 24px;
        }
      }

      .wxBindText {
        color: var(--font-color2);
        font-size: 14px;
        margin-bottom: 83px;
        line-height: 18px;
      }
    }
  }
}
</style>
